import i18n from "../../../../i18n";

export const _collectionsBasicInfo = (_mappedMetadata: any) => {
  return [
    ...(_mappedMetadata?.collectionDescription && i18n.language === 'el'
      ? [{
        name: 'Περιγραφή Συλλογής',
        value: '',
        refValue: 'collectionDescription',
      }] :
      []),
    ...(_mappedMetadata?.collectionDescriptionEN && i18n.language === 'en'
      ? [{
        name: 'Περιγραφή Συλλογής',
        value: '',
        refValue: 'collectionDescriptionEN',
      }] :
      []),
    ...(_mappedMetadata?.collectionId
      ? [{
        name: 'Αναγνωριστικό Συλλογής',
        value: '',
        refValue: 'collectionId',
      }] :
      []),
    ...(_mappedMetadata?.collectionsComments && i18n.language === 'el'
      ? [{
        name: 'Παρατηρήσεις Σχόλια Συλλογής',
        value: '',
        refValue: 'collectionsComments'
      }] :
      []),
    ...(_mappedMetadata?.collectionsCommentsEn && i18n.language === 'en'
      ? [{
        name: 'Παρατηρήσεις Σχόλια Συλλογής',
        value: '',
        refValue: 'collectionsCommentsEn'
      }] :
      []),
  ];
};

export const _foreas = (_mappedMetadata: any) => {
  return [
    ...(_mappedMetadata?.collectionOrganisation && i18n.language === 'el'
      ? [{
        name: 'Φορέας Συλλογής',
        value: '',
        refValue: 'collectionOrganisation'
      }] :
      []),
    ...(_mappedMetadata?.collectionOrganisationEn && i18n.language === 'en'
      ? [{
        name: 'Φορέας Συλλογής',
        value: '',
        refValue: 'collectionOrganisationEn'
      }] :
      []),
  ];
};
